import { AVATAR_TYPES } from '../Constants';
export const getDefaultAvatarType = type => {
  if (type && type in AVATAR_TYPES) {
    return AVATAR_TYPES[type];
  }
  return undefined;
};